import { InviteFriends } from '../../pages/Settings';
import React from 'react';

const InviteFriendsContainer = ({ closeModal }) => {
	return <InviteFriends closeModal={closeModal} />;
};

export default InviteFriendsContainer;
